import { useDebounce } from 'ahooks';
import { AutoComplete, AutoCompleteProps } from 'antd';
import { useState } from 'react';

import { AddressAutocompleteItem } from '@/models/address.model';
import { useLocationAutocomplete } from '@/web-api/addresses/useLocationAutocomplete';

type AddressInputProps = {
  placeholder: string;
  value: string | undefined;
  onSelect: (label: string, value: AddressAutocompleteItem) => void;
  onChange?: (value: string) => void;
  props?: AutoCompleteProps<string, AddressAutocompleteItem>;
};

export const AddressInput = ({
  placeholder,
  value,
  onSelect,
  onChange,
  props,
}: AddressInputProps) => {
  const [searchValue, setSearchValue] = useState(value);
  const debouncedValue = useDebounce(searchValue, { wait: 200 });

  const { data } = useLocationAutocomplete(debouncedValue ?? '');

  const handleSelect = (selectedId: string) => {
    const selectedOption = data?.find((option) => option.id === selectedId);
    if (selectedOption) {
      onSelect(selectedOption.label ?? '', selectedOption);
    }
  };

  return (
    <AutoComplete
      {...props}
      value={value}
      placeholder={placeholder}
      options={data?.map((option) => ({ label: option.label, value: option.id }))}
      onSelect={handleSelect}
      onSearch={setSearchValue}
      onChange={onChange}
    />
  );
};
